































































































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import TaskService from '@/domain/task/task.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import DateFormat from '@/shared/utils/date-format';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import BillingService from '@/domain/billing/service/billing.service';
import AuthenticationService from '@/domain/security/authentication.service';
import BillingList from '@/domain/billing/entity/billing-list.entity';
import routeTo from '@/router/routeTo';
import BillingInvoiceCompetence from '@/domain/billing/entity/billing-invoice-competence.entity';

@Component({
  components: {
    MainButton,
    LabelSlot,
    ModalComponent,
  },
  filters: {
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
  },
})
export default class BillingModalInvoice extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  competence: string = '';

  competenceAt: string = '';

  pickerMenu: boolean = false;

  pickerMenuAt: boolean = false;

  loading: boolean = false;

  userEmail: string = '';

  executionId: string = '';

  created() {
    this.setPastMonthCompetence();
    this.userEmail = AuthenticationService.userLoggedIn().email;
  }

  goToBillingInfoView(item: BillingList): void {
    if (item.deleted) return;
    const route: any = {
      name: 'FaturamentoInfo',
      params: {
        billingId: item.id,
        businessUnitId: this.businessUnitId,
      },
    };
    routeTo(this.$router, route)
  }

  get pastMonth(): string {
    const date: Date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    return new Date(date).toISOString().substr(0, 7);
  }

  get month(): string {
    const date: Date = new Date();
    date.setDate(1);
    return new Date(date).toISOString().substr(0, 7);
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  setPastMonthCompetence(): void {
    this.competence = this.pastMonth;
  }

  setMonthCompetence(): void {
    this.competenceAt = this.month;
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  executeInvoiceByCompetence() {
    this.startLoading();
    if (!this.competence || !this.competenceAt || this.competence > this.competenceAt) {
      this.handleMessageError('Preencha corretamente os campos de competência.');
      return;
    }
    this.exportToEmailCompetence()
  }

  exportToEmailCompetence(): void {
    const requestFilter: BillingInvoiceCompetence = BillingInvoiceCompetence.of({
      competence: this.competence,
      competenceAt: this.competenceAt,
    });
    BillingService.exportToEmailInvoiceByCompetence(
      this.businessUnitId,
      this.userEmail,
      requestFilter,
    );
    setTimeout(() => {
      this.stopLoading();
      this.modalState = false;
    }, 3.5 * 1000);
  }

  private handleMessageError(err: string) {
    this.stopLoading();
    VbSnackbarService.showError(err);
    this.$emit('executionError');
  }
}
